export {
  DIALONCE_CLOSE_PAYLOAD,
  notifyHostClose,
  type DialonceClosePayload,
  type HostCloseWindow,
} from "./notifyHostClose";
